// @flow
import type { SocialContent, SocialProvider } from 'types/SocialContent';
import { AllProvider } from 'constants/socialConstants';

export function getValidSocialCards(socialCards: Array<SocialContent>, provider: SocialProvider): Array<SocialContent> {
  const validSocialCards = provider === AllProvider ? socialCards : socialCards.filter(card => card.type === provider);
  return validSocialCards.sort(function(a, b) {
    const aDate = new Date(a.date);
    const bDate = new Date(b.date);
    return aDate < bDate ? 1 : aDate > bDate ? -1 : 0;
  });
}
